module.exports = __webpack_public_path__ + "static/media/W18-0469_AW_Jalapeno_Cheddar_mobile_hero_en.ad1ea812.jpg";